
    const data = {"name":"src/core/icons/alert-decagram","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m23 12-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12m-10 5h-2v-2h2v2m0-4h-2V7h2v6Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            